module.exports = __webpack_public_path__ + "media/images/favicon-32x32-7f4e91096a244b32a3135639671e4618.png";